import { RootState } from '@/store';
import { createSelector } from '@reduxjs/toolkit';

export const selectClients = (state: RootState) => state.clients;

export const selectClientsData = createSelector([selectClients], ({ data, filters, total, dataRequestId }) => ({
  data,
  filters,
  total,
  loading: !!dataRequestId,
}));

export const selectClientsFilters = createSelector([selectClients], ({ filters }) => filters);

export const selectSelectedClient = createSelector([selectClients], ({ selectedClient }) => selectedClient);

export const selectClientsControlOptions = createSelector(
  [selectClients],
  ({ agencies, advertisers, advertisersRequestId, agenciesRequestId }) => ({
    agencies,
    advertisers,
    loading: !!(agenciesRequestId || advertisersRequestId),
  }),
);
